import { createContext } from 'react'

const DaiChatPanelSizeContext = createContext()

export default DaiChatPanelSizeContext
